import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/customer-dashboard/orders/page.tsx");
